export default __webpack_public_path__ + "static/media/arrow-up-small-footer.2a5519a9.svg";